<script>
    import R, {LOADER} from "../lib/requests";
    import {SERVICE_TYPE} from "../lib/constants";
    import {sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import ServicesList from "./ServicesList.svelte";
    import WsServiceSelectControl from "../components/controls/WsServiceSelectControl.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import DateControl from "../components/controls/DateControl.svelte";


    export let clientId = null;
    export let services = null;

    let search = {
        ws_service_id: "",
        client_id: "",
        expires_at: '',
    }


    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ', class: 'hidden-xs'},
        {key: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    let servicesList;
    let serviceId = 0;
    let editServiceId = null;
    let renewServiceId = null;
    let entitiesServiceId = null;

    const load = (loader = LOADER.PAGE) => {

        const onSuccess = result => {
            services = result;
        }

        const onFailure = err => {
        };

        R.handle(R.service.index, search, onSuccess, onFailure, loader);
    };


    const onCreate = () => {
        servicesList.create();
    }

    const onEdit = (service) => {
        serviceId = service.id;
        editServiceId = service.id;
    }

    const closeEdit = () => {
        editServiceId = null;
    }

    const onRenew = (service) => {
        renewServiceId = service.id;
    }

    const closeRenew = () => {
        renewServiceId = null;
    }

    const onDelete = (service) => {
        Alert.delete("Διαγραφή", `Να διαγραφεί η υπηρεσία "${service.name}";`, () => deleteService(service.id));
    }

    const deleteService = (id) => {
        const onSuccess = result => {
            services = services.filter(x => x.id != result);
            Notifier.showMessage("Η υπηρεσία διαγράφτηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.service.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const updateService = (service) => {
        let srv = services.find(x => x.id === service.id);
        if (!srv) {
            services = [service, ...services];
        } else {
            srv.name = service.name;
        }
        serviceId = service.id;
    }

    const onShowEntities = (service) => {
        if (service.type == SERVICE_TYPE.SUBSCRIPTION) {
            serviceId = service.id;
            if (entitiesServiceId == service.id) {
                entitiesServiceId = null;
            } else {
                entitiesServiceId = service.id;
            }
        }
    }

    const onColumnSort = ({detail: column}) => {
        entitiesServiceId = null;
        services.sort_column = column;
        sortList();
    };

    const sortList = () => {
        services = sort(services, services.sort_column.key, services.sort_column.sort_way === 'DESC');
    }

    const onSearchChange = () => {
        load(LOADER.POPUP);
    }

    const clearSearch = () => {
        search.ws_service_id = "";
        search.client_id = "";
        load();
    }
</script>
<PageHeader title="Υπηρεσίες" controls="{ pageHeaderControls }" on:create={ onCreate } on:reload={ load }/>

<div class="panel-simple p-2 mb-4">
    <div class="row">
        <div class="col-md-2">
            <DateControl topInfo="Λήξη έως" bind:value="{ search.expires_at }" on:change={ onSearchChange }/>
        </div>
        <div class="col-md-2">
            <WsServiceSelectControl bind:value="{ search.ws_service_id }" on:change={ onSearchChange }/>
        </div>
        <div class="col-md-7">
            <ClientControl bind:clientId={ search.client_id } allowCreate="{ false }" on:select={ onSearchChange } placeholder="πελάτης"/>
        </div>
        <div class="col-md-1">
            <button class="btn btn-primary btn-block px-0" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-body">
        <ServicesList bind:this={ servicesList } {services} />
    </div>
</div>


<!--{#if editServiceId != null}-->
<!--    <ServiceEdit serviceId="{ editServiceId }" {clientId} updateCallback="{ updateService }"-->
<!--                 closeCallback="{ closeEdit }"/>-->
<!--{/if}-->
{#if renewServiceId != null}
<!--    <ServiceRenew serviceId="{ renewServiceId }" updateCallback="{ updateService }" closeCallback="{ closeRenew }"/>-->
{/if}

<style>
    .ws-service-name {
        font-size: 8px;
        line-height: 1;
    }
</style>

<!--<Route match="create">-->
<!--    <ServiceEdit editCallback="{ updateService }" serviceId="{0}"/>-->
<!--</Route>-->
<!--<Route match="edit" let:router>-->
<!--    <ServiceEdit editCallback="{ updateService }" serviceId="{ router.id }"/>-->
<!--</Route>-->
